(-> __whmodules.init())()
